import React, { useEffect, useState } from 'react';

import { Row, useModelStateContext } from 'saladsoft-primitive';
import InputField from 'components/input/InputField';
import styled from 'styled-components';
import { useStoreWrapper } from 'stores/StoreHelper';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ServiceHelper from 'stores/ServiceHelper';
import Button from 'components/input/Button';
import { EmailLoginDto } from 'services/data-contracts';
import { useLocale } from 'providers/LocalProvider';
import { validationHelper } from 'controls/validationHelper';

const LoginPage = () => {
  const navigate = useNavigate();

  const { setState, stateModel } = useModelStateContext<EmailLoginDto>();
  const { initLocales } = useLocale();

  const [isValid, setIsValid] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleClickLogin = async () => {
    if (stateModel) {
      setBusy(true);
      const result = await ServiceHelper.authService?.loginWithEmail(stateModel);
      if (result?.status === 200) {
        localStorage.setItem('accessToken', result?.data.accessToken || '');
        localStorage.setItem('refreshToken', result?.data.refreshToken || '');
        initLocales();
        const roleType = await ServiceHelper.myAccountService?.getMyAccount();
        if (roleType?.data?.roleType === 'ADMIN') {
          navigate('/management/reservations/daily');
        } else {
          navigate('/admin/listings');
        }
      } else {
        toast.warning('아이디 또는 비밀번호가 일치하지 않습니다.');
        setBusy(false);
      }
    }
    setTimeout(() => {
      setBusy(false);
    }, 3000);
  };

  useEffect(() => {
    const userName = validationHelper.required(stateModel?.username);
    const password = validationHelper.password(stateModel?.password);
    setIsValid(userName && password);
  }, [stateModel]);

  return (
    <>
      <Container>
        <LoginBg
          style={{ flex: 0.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <div style={{ margin: 'auto' }}>
            <div>
              <img src="/images/logo_white.png" alt="logo" style={{ width: 150 }} />
            </div>
            <div style={{ fontSize: 50, fontWeight: 'bold', color: 'white' }}>BUTLERLEE</div>
            <div style={{ fontSize: 20, fontWeight: '400', color: 'white' }}>
              Property Management System
            </div>
            <div style={{ marginTop: 40, color: 'white', opacity: 0.5 }}>
              Relax in the midst of the city <br />
            </div>
          </div>
        </LoginBg>
        <div
          style={{
            flex: 0.5,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Row
            maxWidth={400}
            width="100%"
            flexDirection="column"
            gap={20}
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <div
              style={{
                fontSize: 30,
                fontWeight: 'bold',
                color: 'black',
                textAlign: 'left',
              }}
            >
              Login
            </div>

            <InputField
              autoFocus
              label="Username"
              onChange={(e: string) => {
                setState('username', e);
              }}
            />
            <InputField
              label="Password"
              type="password"
              onChange={(e: string) => {
                setState('password', e);
              }}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter') {
                  handleClickLogin();
                }
              }}
            />
            <Button
              busy={busy}
              isValid={isValid}
              onClick={handleClickLogin}
              style={{ width: '100%' }}
            >
              Login
            </Button>
            <div style={{ fontSize: 14, fontWeight: '400', color: 'black', textAlign: 'left' }}>
              로그인 관련문의는 담당자에게 문의 바랍니다.
            </div>
          </Row>
        </div>
      </Container>
    </>
  );
};

const Container = styled.div`
  justify-content: space-between;
  display: flex;
  width: 100vw;
  height: 100vh;
  /* max-width: 1800px; */
  margin: auto;
  justify-content: center;
  align-items: center;
`;

const LoginBg = styled.div`
  background-image: url('../images/loginbg.jpeg');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export default LoginPage;
